// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__shqZt","head":"ProcedureTableInfo_head__2naL7"};